export class InputManager {
  private keys: Set<string> = new Set();
  private consumed: Set<string> = new Set();
  private mouseDx = 0;
  private mouseDy = 0;
  readonly canvas: HTMLCanvasElement;

  // タッチ入力用（MobileControlsから設定される）
  private touchDx = 0;
  private touchDy = 0;
  private touchKeys: Set<string> = new Set();
  private touchConsumed: Set<string> = new Set();

  private _isMobile = false;

  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas;
    this._isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    this.setupListeners();
  }

  get isMobile(): boolean { return this._isMobile; }

  private setupListeners(): void {
    document.addEventListener('keydown', (e) => {
      this.keys.add(e.code);
      if (['Space', 'Tab'].includes(e.code)) e.preventDefault();
    });

    document.addEventListener('keyup', (e) => {
      this.keys.delete(e.code);
      this.consumed.delete(e.code);
    });

    document.addEventListener('mousemove', (e: MouseEvent) => {
      if (document.pointerLockElement === this.canvas) {
        this.mouseDx += e.movementX;
        this.mouseDy += e.movementY;
      }
    });
  }

  /** MobileControlsからジョイスティック入力を受け取る */
  setTouchAxis(dx: number, dy: number): void {
    this.touchDx = dx;
    this.touchDy = dy;
  }

  /** MobileControlsから仮想キー押下を設定 */
  setTouchKey(code: string, pressed: boolean): void {
    if (pressed) {
      this.touchKeys.add(code);
    } else {
      this.touchKeys.delete(code);
      this.touchConsumed.delete(code);
    }
  }

  isDown(code: string): boolean {
    return this.keys.has(code) || this.touchKeys.has(code);
  }

  /** キーが押されたフレームに1度だけtrueを返す */
  consumeKeyOnce(code: string): boolean {
    if (this.keys.has(code) && !this.consumed.has(code)) {
      this.consumed.add(code);
      return true;
    }
    if (this.touchKeys.has(code) && !this.touchConsumed.has(code)) {
      this.touchConsumed.add(code);
      return true;
    }
    return false;
  }

  /** フレームごとにマウス/タッチ移動量を取得してリセット */
  consumeMouse(): { dx: number; dy: number } {
    const result = {
      dx: this.mouseDx + this.touchDx,
      dy: this.mouseDy + this.touchDy,
    };
    this.mouseDx = 0;
    this.mouseDy = 0;
    return result;
  }

  isPointerLocked(): boolean {
    if (this._isMobile) return true;
    return document.pointerLockElement === this.canvas;
  }

  requestPointerLock(): void {
    this.canvas.requestPointerLock();
  }
}
